import { render } from "./InspectionQuestions.vue?vue&type=template&id=c4dec0c2"
import script from "./InspectionQuestions.vue?vue&type=script&lang=js"
export * from "./InspectionQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__